/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

/**
 * Moves an array element to another index - modifies the original array
 *
 * @param arr Array
 * @param oldIndex Old index
 * @param newIndex New index
 */
export function arrayMove(arr, oldIndex, newIndex) {

	if (newIndex >= arr.length) {

		let k = newIndex - arr.length + 1;
		while (k--) {
			arr.push(undefined);
		}

	}

	arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

};
